import React from 'react'
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

import { ThemeProvider } from '@mui/material/styles';
import { theme } from './util/theme';
import { routes } from './routes';
import { CssBaseline } from '@mui/material';

function App() {

  const router = createBrowserRouter(routes);

  return (
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <RouterProvider router={router} />
      </ThemeProvider>
    </React.StrictMode>
  );
}

export default App;